import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';
import './Hero.scss'
import bg from '../../../../../assets/images/Industry_bg.png'
import AOS from 'aos';
import 'aos/dist/aos.css';

const Hero = ({homeContent}) => {
  useEffect(() => {
    AOS.init({
      duration: 1000,
      once: true,
      mirror: false,
      offset: 50
    });
  }, []);

  return (
    <div className="hero-sections">
      <img src={bg} alt="background" className="hero-bg" />
      <div className="container">
        {/* Breadcrumb Navigation */}
        <nav className="breadcrumb-nav" aria-label="breadcrumb">
          <ol className="breadcrumb-list">
            <li><Link to="/">Home</Link></li>
            <li><Link to="/industries">Industries</Link></li>
            <li className="active">{homeContent.breadcrumb}</li>
          </ol>
        </nav>
        {/* Main Hero Content */}
        <div className="hero-row">
          <div className="hero-content" data-aos="fade-right" data-aos-delay="100">
            <h1 className="hero-title" data-aos="fade-up" data-aos-delay="200">
              {homeContent.title}
            </h1> 
            <p className="hero-description" data-aos="fade-up" data-aos-delay="300">
              {homeContent.description}
            </p>
            <button className="hero-btn" data-aos="fade-up" data-aos-delay="400">
              {homeContent.b}
            </button>
          </div>
          <div className="hero-images" data-aos="fade-left" data-aos-delay="200">
            <img 
              src={homeContent.image} 
              alt={homeContent.imageAlt} 
              className="hero-mockup"
              data-aos="zoom-in"
              data-aos-delay="500"
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default Hero;